import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "21.9998",
  height: "22",
  rx: "10.9999",
  fill: "#EFF0F1"
}, null, -1)
const _hoisted_3 = ["fill"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'arrowRight',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#387DFF",
  },
  width: {
    type: Number as PropType<number | string>,
    default: 22,
  },
  height: {
    type: Number as PropType<number | string>,
    default: 22,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: __props.width,
    height: __props.height,
    viewBox: "0 0 22 22",
    fill: "none"
  }, [
    _hoisted_2,
    _createElementVNode("path", {
      d: "M10.2192 14.8464L14.294 11.2518C14.3282 11.2194 14.3555 11.1804 14.3741 11.1372C14.3927 11.0939 14.4023 11.0473 14.4023 11.0002C14.4023 10.9531 14.3927 10.9065 14.3741 10.8632C14.3555 10.82 14.3282 10.781 14.294 10.7486L10.2192 7.15404C10.1868 7.1253 10.149 7.10328 10.1081 7.08926C10.0671 7.07523 10.0238 7.06948 9.98061 7.07234C9.93707 7.07589 9.89468 7.08812 9.85596 7.10833C9.81723 7.12853 9.78295 7.1563 9.75513 7.18998L9.24864 7.79452C9.22007 7.82754 9.19841 7.86596 9.18494 7.90749C9.17147 7.94902 9.16646 7.99283 9.17021 8.03634C9.17334 8.07963 9.18507 8.12187 9.20471 8.16058C9.22434 8.1993 9.2515 8.23371 9.28458 8.26181L12.3726 10.9446C12.389 10.9612 12.3981 10.9835 12.3981 11.0067C12.3981 11.03 12.389 11.0523 12.3726 11.0688L9.28458 13.7386C9.22148 13.7914 9.18064 13.8661 9.17021 13.9477C9.16602 13.991 9.17051 14.0347 9.18341 14.0762C9.19632 14.1177 9.21738 14.1563 9.24537 14.1895L9.75513 14.8104C9.78295 14.8441 9.81723 14.8719 9.85596 14.8921C9.89468 14.9123 9.93707 14.9245 9.98061 14.9281C10.0238 14.9309 10.0671 14.9252 10.1081 14.9111C10.149 14.8971 10.1868 14.8751 10.2192 14.8464Z",
      fill: __props.color
    }, null, 8, _hoisted_3)
  ], 8, _hoisted_1))
}
}

})